/**
 * @generated SignedSource<<6282b5dc57e908605b438a96bc5ab475>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VertexGenAIPromptType = "analyse" | "highlights" | "summarise";
export type GCP_vertexGenAi_Query$variables = {
  customPrompt?: string | null | undefined;
  mediaItemId?: string | null | undefined;
  promptType?: VertexGenAIPromptType | null | undefined;
  textContent?: string | null | undefined;
  url?: string | null | undefined;
};
export type GCP_vertexGenAi_Query$data = {
  readonly vertexGenAi: {
    readonly summary: string | null | undefined;
  } | null | undefined;
};
export type GCP_vertexGenAi_Query = {
  response: GCP_vertexGenAi_Query$data;
  variables: GCP_vertexGenAi_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customPrompt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mediaItemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promptType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "textContent"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "url"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customPrompt",
        "variableName": "customPrompt"
      },
      {
        "kind": "Variable",
        "name": "mediaItemId",
        "variableName": "mediaItemId"
      },
      {
        "kind": "Variable",
        "name": "promptType",
        "variableName": "promptType"
      },
      {
        "kind": "Variable",
        "name": "textContent",
        "variableName": "textContent"
      },
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "VertexGenAi",
    "kind": "LinkedField",
    "name": "vertexGenAi",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GCP_vertexGenAi_Query",
    "selections": (v5/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GCP_vertexGenAi_Query",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a2fbaf159c8a0243b26c3c4d60c4a6f7",
    "id": null,
    "metadata": {},
    "name": "GCP_vertexGenAi_Query",
    "operationKind": "query",
    "text": "query GCP_vertexGenAi_Query(\n  $url: String\n  $mediaItemId: ID\n  $textContent: String\n  $promptType: VertexGenAIPromptType\n  $customPrompt: String\n) {\n  vertexGenAi(url: $url, mediaItemId: $mediaItemId, textContent: $textContent, promptType: $promptType, customPrompt: $customPrompt) {\n    summary\n  }\n}\n"
  }
};
})();

(node as any).hash = "990800ddfe5eaa228f3c5fcddfe34da2";

export default node;
